import React, { useEffect, useState, useContext } from 'react';
import { ApiDispatchContext } from "../../../context/ApiContext";
import ErrorAlert from "../../../components/ErrorAlert";
import { getUrlParameter } from "../../../constants/commonFunction";
import './cardtab.css'
import UploadedFileView from '../../../components/UploadedFileView';

export const Policy = () => {
    const [policy, setPolicy] = useState("");
    const [documents, setDocuments] = useState("");
    const api = useContext(ApiDispatchContext);
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalBody, setModalBody] = useState("");
    const toggle = () => setModal(!modal);
    let casid = Number(getUrlParameter('case'));

    useEffect(() => {
        if (casid) {
            let payload = {
                "caseId": casid,
                "segmentType": "policy"
            }
            api.getCaseBPRSegmentDetails(payload).then(data => {
                if (data.data && data.data.success && (data.data.data.data.length || data.data.data.documents.length)) {
                    setPolicy(data.data.data.data)
                    setDocuments(data.data.data.documents)
                }
            }).catch(err => {
                setModalTitle("Error");
                if(err && err.response && err.response.data && err.response.data.message){
                    setModalBody(err.response.data.message);
                  } else {
                    setModalBody('Please try after sometime');
                  }
                toggle();
            })
        }
    }, [casid]);

    return (
        <div className='policy'>
            <div className='map-data'>
                {Array.isArray(policy) && policy.map((ele, i) => (
                    <div className="map-data-breakDIV">
                        <div className='map-data-text1'>{ele.label}</div>
                        <div className='map-data-text2'>{ele.value ? ele.value : '-'}</div>
                    </div>
                ))}
            </div>
            {documents.length > 0 && (
                <>
                    <hr />
                    <span className='rein-document-title'>Documents</span>
                    <div className="rein-docs-container">
                        {Array.isArray(documents) && documents.length > 0 && 
                          <UploadedFileView download={false} border="1px solid #EBAF00" documentList={documents}  />
                        }
                    </div>
                </>
            )}
            <ErrorAlert
                modal={modal}
                toggle={toggle}
                modalTitle={modalTitle}
                modalBody={modalBody}
            />
        </div>
    )
}

Policy.propTypes = {};

export default Policy;